var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclaimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3333 36.6V62.8H133.667V36.6H153.274C157.54 36.6 161 40.0706 161 44.3485V169.251C161 173.531 157.54 177 153.274 177H28.7264C24.4592 177 21 173.53 21 169.251V44.3485C21 40.0691 24.4607 36.6 28.7264 36.6H48.3333ZM97.6667 128H42.1111V143.6H97.6667V128ZM77.6667 104.6H42.1111V120.2H77.6667V104.6ZM107.667 81.2H42.1111V96.8H107.667V81.2ZM122.111 25V52.2H59.8889V25H122.111Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 43,
    r: 24,
    fill: "#304FF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.678 36.7751L164.83 30.7415C165.117 30.1919 165.797 29.9796 166.348 30.2674L167.345 30.7885C168.289 33.7886 171.422 36.8297 173.445 38.5526L167.843 49.2748C165.273 48.5979 160.988 47.7634 157.986 48.7014L156.988 48.1803C156.438 47.8925 156.224 47.2137 156.511 46.6641L159.664 40.6304C158.919 39.96 158.69 38.8485 159.175 37.9211C159.659 36.9937 160.702 36.5466 161.678 36.7751ZM179.228 42.0644C180.33 42.64 180.757 43.9977 180.183 45.0969L177.063 51.0679C176.489 52.1672 175.13 52.5916 174.028 52.0161L173.031 51.495L169.434 55.9497L167.439 54.9075L175.239 39.9801L179.228 42.0644Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7768 168.083L54.7145 165.927C55.8794 171.686 52.3874 177.44 46.6348 179.003L38.6972 181.159C37.5322 175.4 41.0242 169.646 46.7768 168.083Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7768 168.083L54.7145 165.927C55.8794 171.686 52.3874 177.44 46.6348 179.003L38.6972 181.159C37.5322 175.4 41.0242 169.646 46.7768 168.083Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7768 168.083L54.7145 165.927C55.8794 171.686 52.3874 177.44 46.6348 179.003L38.6972 181.159C37.5322 175.4 41.0242 169.646 46.7768 168.083Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4189 175.198L8.96027 165.324C19.1736 162.164 30.1379 167.632 33.7019 177.806L37.1605 187.68C26.9472 190.839 15.9829 185.371 12.4189 175.198Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4189 175.198L8.96027 165.324C19.1736 162.164 30.1379 167.632 33.7019 177.806L37.1605 187.68C26.9472 190.839 15.9829 185.371 12.4189 175.198Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4189 175.198L8.96027 165.324C19.1736 162.164 30.1379 167.632 33.7019 177.806L37.1605 187.68C26.9472 190.839 15.9829 185.371 12.4189 175.198Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.335 113.288C139.001 106.938 148.166 106.938 151.832 113.288L187.919 175.792C191.585 182.141 187.002 190.078 179.67 190.078H107.497C100.165 190.078 95.5824 182.141 99.2484 175.792L135.335 113.288Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "3.57 3.57"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.925 150.894L145.817 162.621L145.988 167.729L140.331 167.729L140.502 162.621L141.394 150.894L144.925 150.894ZM143.142 141.739C144.925 141.739 146.194 143.008 146.194 144.791C146.194 146.574 144.891 147.808 143.142 147.808C141.428 147.808 140.125 146.574 140.125 144.791C140.125 143.008 141.428 141.739 143.142 141.739Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimer);
export default __webpack_public_path__ + "static/media/disclaimer.b24659cdbb95c313647dbad2be3e65b0.svg";
export { ForwardRef as ReactComponent };